/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_No_Match_BodyInputs */

const id_staff_resellers_no_match_body = /** @type {(inputs: Staff_Resellers_No_Match_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah pencarian atau saringan statusnya.`)
};

const en_staff_resellers_no_match_body = /** @type {(inputs: Staff_Resellers_No_Match_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the search or the status filter.`)
};

/**
* | output |
* | --- |
* | "Change the search or the status filter." |
*
* @param {Staff_Resellers_No_Match_BodyInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_no_match_body = /** @type {((inputs?: Staff_Resellers_No_Match_BodyInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_No_Match_BodyInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_no_match_body(inputs)
	return id_staff_resellers_no_match_body(inputs)
});